/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Max_Wpm_LabelInputs */

const en_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Reading Rate`)
};

const fr_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse de lecture maximale`)
};

const de_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Lesegeschwindigkeit`)
};

const it_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità di lettura massima`)
};

const ru_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная скорость чтения`)
};

const es_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad máxima de lectura`)
};

const zh_cn2_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大阅读速率`)
};

const ja_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大読書速度`)
};

const hi_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम पठन दर`)
};

const pt_pt2_ad_max_wpm_label = /** @type {(inputs: Ad_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa máxima de leitura`)
};

/**
* | output |
* | --- |
* | "Max Reading Rate" |
*
* @param {Ad_Max_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_max_wpm_label = /** @type {((inputs?: Ad_Max_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Max_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_max_wpm_label(inputs)
	if (locale === "de") return de_ad_max_wpm_label(inputs)
	if (locale === "it") return it_ad_max_wpm_label(inputs)
	if (locale === "ru") return ru_ad_max_wpm_label(inputs)
	if (locale === "es") return es_ad_max_wpm_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_max_wpm_label(inputs)
	if (locale === "ja") return ja_ad_max_wpm_label(inputs)
	if (locale === "hi") return hi_ad_max_wpm_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_max_wpm_label(inputs)
	return en_ad_max_wpm_label(inputs)
});